import { takeReduxPersisted } from '@/lib/takeReduxPersisted';
import genGuid from '@whiz-cart/node-shared/guid';
import type { MhdItem } from '@whiz-cart/node-shared/models/mhd/mhdItem';
import { createStore, persist } from 'cross-state';

export type StoredMhdItem = Omit<MhdItem, 'expireOn'> & { expireOn?: string | null; updatedOn?: string; updatedBy?: string };

export interface MhdState {
    items: Record<string, StoredMhdItem>;
    /** Local updates not yet handed to the service worker */
    queue: StoredMhdItem[];
    deviceId: string;
}

export const mhdStore = createStore<MhdState>({ items: {}, queue: [], deviceId: '' });

const persistence = persist(mhdStore, { id: 'mhd', storage: localStorage });

export const mhdReady = persistence.initialized.then(() => {
    const legacy = takeReduxPersisted('mhd');
    if (legacy?.items && typeof legacy.items === 'object') mhdStore.set('items', legacy.items as MhdState['items']);
    if (Array.isArray(legacy?.queue)) mhdStore.set('queue', legacy.queue);
    // Initial state is not persisted, so the id has to be set explicitly to survive a reload
    const deviceId = typeof legacy?.deviceId === 'string' ? legacy.deviceId : mhdStore.get().deviceId || genGuid();
    mhdStore.set('deviceId', deviceId);
});

export const setMhdItem = (item: StoredMhdItem) => mhdStore.set('items', (items) => ({ ...items, [item.id]: item }));

export const enqueueMhdItem = (item: StoredMhdItem) => mhdStore.set('queue', (queue) => [...queue, item]);

export const dequeueMhdItem = () => mhdStore.set('queue', (queue) => queue.slice(1));

export const clearMhd = () => mhdStore.set((state) => ({ ...state, items: {}, queue: [] }));
